module.exports = __webpack_public_path__ + "static/media/playlist-icon.1786c046.svg";